// Sama brand tokens — sourced from the org "Sama Design System" (claude.ai/design).
// The previous values were off-brand (primary #002B38, mixed 10/12/16px radii).
// These mirror the brand guidelines so the auth handoff matches the rest of Sama.

/** Core palette + ramps. Viridian and neutrals dominate; teal/orange punctuate. */
export const COLORS = {
    viridian: '#1F3F48', // primary brand color (brand band / header)
    // Live coachee-web primary CTA green — sampled from the destination
    // "Continue" button so this handoff's buttons match the page it leads to.
    action: '#286977',
    viridian050: '#EAF0F1',
    noir: '#090714',
    ivory: '#FFFFFF',
    pageWhite: '#FAFAFA', // off-white page background
    teal: '#A8EAF6', // primary accent
    orange: '#FF7558', // secondary accent
    neutral700: '#3A3A3A',
    neutral500: '#6B6F70',
    neutral300: '#D3D3D3',
    neutral200: '#E5E5E5', // subtle hairline
    neutral100: '#F3F4F4',
} as const

// Real Founders Grotesk faces ship in /public/fonts as Light (300) + Medium (500)
// only — there is NO Regular/Bold file, so the global `FoundersGroteskRegular`
// @font-face 404s and body text silently falls back to the system sans. This
// surface renders entirely in the Medium face, with an explicit grotesque
// fallback stack pinned so it always stays in-brand.
const FALLBACK =
    "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif"
export const FONT = {
    display: `'FoundersGroteskMedium', ${FALLBACK}`, // headings, labels, actions
} as const

// Brand rule: exactly one friendly radius (18px) or square (0). Buttons/chips are pills.
export const RADIUS = {
    md: 18,
    pill: 999,
} as const

// Restrained — the brand is mostly flat.
export const SHADOW = {
    sm: '0 1px 2px rgba(9, 7, 20, 0.06)',
    md: '0 10px 30px rgba(9, 7, 20, 0.10)',
    lg: '0 28px 70px rgba(9, 7, 20, 0.16)',
} as const

// Subtle, functional motion: ~120ms eases, press scales to 0.985, hover darkens.
export const MOTION = {
    ease: '120ms cubic-bezier(0.4, 0, 0.2, 1)',
} as const
